import { useMemo } from 'react';
import { useRecordContext } from 'react-admin';
import get from 'lodash/get';
import type { ChipColor, PillButtonFieldProps, UseController } from './types';
import { CUSTOM_COLOR_PREFIX, EMPTY_VALUES } from './constants';

export const useController = (props: PillButtonFieldProps & Record<string, unknown>): UseController | null => {
  const { color = 'default', colorMap, source, valueMap } = props;

  const record = useRecordContext(props);

  return useMemo(() => {
    const raw = get(record, source);

    if (EMPTY_VALUES.has(raw)) return null;

    // Map label
    const displayValue = valueMap[raw] ?? raw;

    // Resolve chip color (value-specific overrides default)
    const resolvedColor: ChipColor = colorMap && raw in colorMap ? colorMap[raw] : color;

    const isCustomColor = typeof resolvedColor === 'string' && resolvedColor.startsWith(CUSTOM_COLOR_PREFIX);

    return {
      rawValue: raw,
      displayValue,
      chipColor: resolvedColor,
      isCustomColor,
    };
  }, [record, source, valueMap, color, colorMap]);
};
